module.exports = __webpack_public_path__ + "img/566.eb61f829.gif";